import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Alert, Skeleton } from 'antd';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
import { fetchCurrentTeam, fetchSubscriptions, fetchTeamStorageStatistics, } from 'api/team-api';
import { BeeyLocale } from 'libs/locales/locale';
import { useUploadQueue } from 'screens/DashboardScreen/dashboard-context';
import FormModal from 'components/FormModal';
import { useHistory } from 'react-router';
import { BYTES_IN_GIGABYTE } from 'libs/utils';
import LoadedContent from './LoadedContent';
import styles from './style.module.less';
const TranscribeModal = ({ visible, onClose, project, }) => {
    var _a;
    const { session, refetchLogin } = useSession();
    const uploadQueue = useUploadQueue();
    const history = useHistory();
    const [shouldRedirectToProject, setShouldRedirectToProject] = useState(false);
    const [transcriptionSetup, setTranscriptionSetup] = (useState('loading'));
    const getStorageLimitInGB = (subscription) => {
        const { storageLimit } = subscription.items[0].planMetadata;
        return Number(storageLimit) * BYTES_IN_GIGABYTE;
    };
    const getStorageLimitFromTeamPlan = async () => {
        const subs = await fetchSubscriptions(session.connection);
        if (subs.isSuccess() && subs.get().list.length !== 0) {
            return getStorageLimitInGB(subs.get().list[0]);
        }
        return 0;
    };
    useEffect(() => {
        if (visible) {
            const fetchTranscriptionSetup = async () => {
                var _a;
                let availableStorage = 0;
                if (session.login.hasClaim('orders:list')) {
                    const subscriptions = await fetchSubscriptions(session.connection);
                    if (subscriptions.isSuccess()) {
                        const activeSubscription = subscriptions.get().list.find((sub) => sub.isActive);
                        const storageLimit = activeSubscription === null || activeSubscription === void 0 ? void 0 : activeSubscription.items[0].planMetadata.storageLimit;
                        if (storageLimit !== undefined) {
                            availableStorage = storageLimit * BYTES_IN_GIGABYTE;
                        }
                    }
                    if (subscriptions.isFail() || subscriptions.get().list.length === 0) {
                        // NOTE Code around teamPlan will become obsolete soon and will be deleted
                        availableStorage = await getStorageLimitFromTeamPlan();
                    }
                }
                else {
                    availableStorage = await getStorageLimitFromTeamPlan();
                }
                const storageStatistics = await fetchTeamStorageStatistics(session.connection);
                const usedStorage = storageStatistics.bytesPerShareCount.reduce((acc, stat) => acc + stat.bytes, 0);
                const storedLocale = session.login.user.settings.transcriptionSettings.recognitionLocale;
                const userLanguage = session.login.user.uiLocale;
                const initialLocale = storedLocale === null
                    ? userLanguage
                    : (_a = BeeyLocale.fromCode(storedLocale)) !== null && _a !== void 0 ? _a : userLanguage;
                const team = await fetchCurrentTeam(session.connection);
                setTranscriptionSetup({
                    initialLocale,
                    credit: team.remainingTotalCredit,
                    remainingStorage: availableStorage - usedStorage,
                });
            };
            void fetchTranscriptionSetup();
            void refetchLogin();
        }
    }, [visible]);
    const redirectUrlProject = (projectId) => {
        history.push(`/edit/${projectId}`);
    };
    useEffect(() => {
        // NOTE: Redirect to file project is dependent on the queue status and thus handled in useEffect
        const redirectFileProject = () => {
            var _a;
            if (shouldRedirectToProject && ((_a = uploadQueue.active) === null || _a === void 0 ? void 0 : _a.status) === 'running') {
                if (project !== undefined) {
                    history.push(`/edit/${uploadQueue.active.projectId}/interimEditorRedirect`);
                }
                else {
                    history.push(`/edit/${uploadQueue.active.projectId}`, { mediaFile: uploadQueue.active.mediaFile.getRawFile() });
                }
            }
        };
        redirectFileProject();
    }, [(_a = uploadQueue.active) === null || _a === void 0 ? void 0 : _a.status]);
    const handleSubmit = (result) => {
        if (result.type === 'mic') {
            redirectUrlProject(result.micProjectId);
            return;
        }
        const { mediaOriginsList, urlProjects } = result;
        if ((mediaOriginsList.getAllOrigins().length !== 1)
            || (uploadQueue.isRunning && !uploadQueue.isSolitary)) {
            setShouldRedirectToProject(false);
        }
        else {
            setShouldRedirectToProject(true);
            // NOTE: Redirect to url project can happen instantly.
            if (urlProjects.length > 0) {
                redirectUrlProject(urlProjects[0].id);
            }
        }
    };
    if (!visible) {
        return null;
    }
    return (_jsx(FormModal, { className: styles.transcribeModal, footer: false, open: visible, onCancel: onClose, maskClosable: false, centered: true, children: transcriptionSetup === 'loading'
            ? (_jsxs(_Fragment, { children: [_jsx(Skeleton, { active: true, paragraph: { rows: 2 } }), _jsx(Skeleton, { active: true, paragraph: { rows: 4 } }), _jsx(Skeleton, { active: true, paragraph: { rows: 4 } }), _jsx(Skeleton, { active: true, paragraph: { rows: 3 } })] }))
            : transcriptionSetup === 'empty'
                ? _jsx(Alert, { type: "warning", showIcon: true, message: txt('noTranscriptionOptions') })
                : (_jsx(LoadedContent, { onClose: onClose, onSubmit: handleSubmit, initialLocale: transcriptionSetup.initialLocale, credit: transcriptionSetup.credit, remainingStorage: transcriptionSetup.remainingStorage, project: project })) }));
};
export default TranscribeModal;
